import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export interface TabellePresenze {
    idTabEccedentiQuali: number,
    idTabEccedentiQuanti: number,
    idTabTurniAlt: number,
    idTabGiuRicorrenti: number,
    idTabFlex: number,
    idTabTolleranza: number,
    idTabFasciaDiurna: number,
    idTabFasciaCompetenza: number,

    // boolean 0 false, 1 true
    tabEccedentiQualiPriority: number,
    tabEccedentiQuantiPriority: number,
    tabTurniAltPriority: number,
    tabGiuRicorrentiPriority: number,
    tabFlexPriority: number,
    tabTolleranzaPriority: number,
    tabFasciaDiurnaPriority: number,
    tabFasciaCompetenzaPriority: number,
}

export class TabellePresenze {
    static factory: ObjectFactory<TabellePresenze> = (json?) => {
        return merge<TabellePresenze, Partial<TabellePresenze> | undefined>({
            idTabEccedentiQuali: 0,
            idTabEccedentiQuanti: 0,
            idTabTurniAlt: 0,
            idTabGiuRicorrenti: 0,
            idTabFlex: 0,
            idTabTolleranza: 0,
            idTabFasciaDiurna: 0,
            idTabFasciaCompetenza: 0,

            // boolean 0 false, 1 true
            tabEccedentiQualiPriority: 0,
            tabEccedentiQuantiPriority: 0,
            tabTurniAltPriority: 0,
            tabGiuRicorrentiPriority: 0,
            tabFlexPriority: 0,
            tabTolleranzaPriority: 0,
            tabFasciaDiurnaPriority: 0,
            tabFasciaCompetenzaPriority: 0,
        }, json);
    }
}